type Mode = "portrait" | "landscape" | "original" | "square" | "square_30_26";

export type VariantName =
  | "anchorblock-list"
  | "anchorblock-list-mobile-up"
  | "anchorblock-overlap-summary"
  | "anchorblock-overlap-summary-mobile-up"
  | "anchorblock-stacked"
  | "anchorblock-stacked-mobile-up"
  | "anchorblock-stacked-square3026"
  | "card-list-border-square"
  | "card-list-container-border-original-mobile-up"
  | "card-list-inverted-landscape"
  | "card-list-inverted-original"
  | "card-list-inverted-square"
  | "card-list-inverted-square-mobile-up"
  | "card-list-landscape"
  | "card-list-landscape-mobile-up"
  | "card-list-original"
  | "card-list-original-border"
  | "card-list-portrait"
  | "card-list-summary-border-landscape-mobile-up"
  | "card-list-summary-border-original"
  | "card-list-summary-border-original-mobile-up"
  | "card-list-square"
  | "card-list-square-mobile-up"
  | "card-list-square-aspect-ratio-border-original"
  | "card-list-square-aspect-ratio-original-mobile-up"
  | "card-list-square-aspect-ratio-summary-border-original"
  | "card-list-summary-border-square"
  | "card-stacked-landscape"
  | "card-stacked-landscape-mobile-up"
  | "card-stacked-original"
  | "card-stacked-original-mobile-up"
  | "card-stacked-overlap-summary-portrait"
  | "card-stacked-overlap-summary-portrait-mobile-up"
  | "card-stacked-portrait"
  | "card-stacked-portrait-mobile-up"
  | "card-stacked-square"
  | "card-stacked-square-mobile-up"
  | "card-stacked-typography-landscape-mobile-up"
  | "card-stacked-typography-portrait-mobile-up";

export type VariantByIndex = [number, VariantName];

export const variantConfigMap: Record<
  VariantName,
  {
    mode: Mode;
    direction: "row" | "column" | "row-reverse" | "column-reverse";
    isAnchorBlock?: boolean;
    aspectRatio?: number;
  }
> = {
  "anchorblock-list": {
    mode: "landscape",
    direction: "row",
    isAnchorBlock: true,
  },
  "anchorblock-list-mobile-up": {
    mode: "landscape",
    direction: "row",
    isAnchorBlock: true,
  },
  "anchorblock-overlap-summary": {
    mode: "landscape",
    direction: "column",
    isAnchorBlock: true,
  },
  "anchorblock-overlap-summary-mobile-up": {
    mode: "landscape",
    direction: "column",
    isAnchorBlock: true,
  },
  "anchorblock-stacked": {
    mode: "landscape",
    direction: "column",
    isAnchorBlock: true,
  },
  "anchorblock-stacked-mobile-up": {
    mode: "landscape",
    direction: "column",
    isAnchorBlock: true,
  },
  "anchorblock-stacked-square3026": {
    mode: "square_30_26",
    direction: "column",
    isAnchorBlock: true,
  },
  "card-list-border-square": {
    mode: "square",
    direction: "row",
  },
  "card-list-container-border-original-mobile-up": {
    mode: "original",
    direction: "row",
  },
  "card-list-inverted-landscape": {
    mode: "landscape",
    direction: "row-reverse",
  },
  "card-list-inverted-original": {
    mode: "original",
    direction: "row-reverse",
  },
  "card-list-inverted-square": {
    mode: "square",
    direction: "row-reverse",
  },
  "card-list-inverted-square-mobile-up": {
    mode: "square",
    direction: "row-reverse",
  },
  "card-list-landscape": {
    mode: "landscape",
    direction: "row",
  },
  "card-list-landscape-mobile-up": {
    mode: "landscape",
    direction: "row",
  },
  "card-list-original": {
    mode: "original",
    direction: "row",
  },
  "card-list-original-border": {
    mode: "original",
    direction: "row",
  },
  "card-list-portrait": {
    mode: "portrait",
    direction: "row",
  },
  "card-list-summary-border-landscape-mobile-up": {
    mode: "landscape",
    direction: "row",
  },
  "card-list-summary-border-original": {
    mode: "original",
    direction: "row",
  },
  "card-list-summary-border-original-mobile-up": {
    mode: "original",
    direction: "row",
  },
  "card-list-square": {
    mode: "square",
    direction: "row",
  },
  "card-list-square-mobile-up": {
    mode: "square",
    direction: "row",
  },
  "card-list-square-aspect-ratio-border-original": {
    mode: "original",
    direction: "row",
    aspectRatio: 1,
  },
  "card-list-square-aspect-ratio-original-mobile-up": {
    mode: "original",
    direction: "row",
  },

  "card-list-square-aspect-ratio-summary-border-original": {
    mode: "original",
    direction: "row",
    aspectRatio: 1,
  },
  "card-list-summary-border-square": {
    mode: "square",
    direction: "row",
  },

  "card-stacked-landscape": {
    mode: "landscape",
    direction: "column",
  },
  "card-stacked-landscape-mobile-up": {
    mode: "landscape",
    direction: "column",
  },
  "card-stacked-original": {
    mode: "original",
    direction: "column",
  },
  "card-stacked-original-mobile-up": {
    mode: "original",
    direction: "column",
  },
  "card-stacked-overlap-summary-portrait": {
    mode: "portrait",
    direction: "column",
  },
  "card-stacked-overlap-summary-portrait-mobile-up": {
    mode: "portrait",
    direction: "column",
  },
  "card-stacked-portrait": {
    mode: "portrait",
    direction: "column",
  },
  "card-stacked-portrait-mobile-up": {
    mode: "portrait",
    direction: "column",
  },
  "card-stacked-square": {
    mode: "square",
    direction: "column",
  },
  "card-stacked-square-mobile-up": {
    mode: "square",
    direction: "column",
  },
  "card-stacked-typography-landscape-mobile-up": {
    mode: "landscape",
    direction: "column",
  },
  "card-stacked-typography-portrait-mobile-up": {
    mode: "portrait",
    direction: "column",
  },
};
